import styled from "styled-components"
import { globalMixins } from "../../../assets/styles/styled-components"

export const StyledLink = styled.a`
  display: flex;

  ${(props) =>
    props.activePage &&
    `
    transform: translate(-16px, 0);
    &:before{
      content: "";
      width: 3px;
      margin-right: 12px;
      ${
        props.pageNavProgram === "bba"
          ? ` 
          background-color: ${props.theme.colors.undergraduate};
        `
          : props.pageNavProgram === "masters"
          ? `
            background-color: ${props.theme.colors.masters};
          `
          : props.pageNavProgram === "doctorate"
          ? `
              background-color: ${props.theme.colors.doctorate};
            `
          : props.pageNavProgram === "ashridge"
          ? `
              background-color: ${props.theme.colors.executive};
            `
          : props.pageNavProgram === "mba" &&
            `
              background-color: ${props.theme.colors.mba};
            `
      }
      
    }
    `}

  & img {
    height: 19px;
    margin: auto 0;
    padding-left: 8px;
  }
`

export const StyledDash = styled.span`
  font-size: 16px;
  color: ${(props) => props.theme.colors.darkGrey80};
  font-family: ${(props) => props.theme.fonts.circularMedium};
  margin-right: 8px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 14px;
  }
`

export const StyledLinkContent = styled.div`
  position: relative;
`;

export const StyledHoverLogo = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;

  ${StyledLinkContent}:hover & {
    opacity: 1;
  }
`;
